const hideReactErrorOverlay = () => {
  const ids = [
    "webpack-dev-server-client-overlay",
    "webpack-dev-server-client-overlay-div",
    "react-error-overlay",
  ];

  ids.forEach((id) => {
    const element = document.getElementById(id);

    if (element) {
      element.remove();
    }
  });

  document.querySelectorAll("iframe").forEach((iframe) => {
    if (
      iframe.id?.includes("overlay") ||
      iframe.src?.includes("overlay")
    ) {
      iframe.remove();
    }
  });
};

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const message = event.reason?.message || "";

    if (
      message.includes("ScriptExternalLoadError") ||
      message.includes("remoteEntry.js")
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();

      hideReactErrorOverlay();

      console.log("Microfrontend no disponible");
    }
  },
  true
);

import("./bootstrap");